import React from "react";
import DOMPurify from "dompurify";
import {DynamicComponentProps} from "../../core/_models";

export function HtmlComponent({config: {value}}: DynamicComponentProps) {
    const sanitized = DOMPurify.sanitize(value ?? '');

    return (
        <div className='bg-white text-black rounded p-4'>
            <div className="html-view-component" dangerouslySetInnerHTML={{__html: sanitized}}/>
        </div>
    )
}
